import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import markerImage from "../assets/images/stack.png";
import { Marker, Popup } from "react-leaflet";
import L from "leaflet";
// import { useNavigate } from "react-router-dom";

const StacksMarker = (props) => {
  const stackIcon = L.icon({
    iconUrl: markerImage,
    iconSize: [18, 40],
    iconAnchor: [7, 40],
    popupAnchor: [4, -5],
  });
  const isLoggedIn = useSelector((state) => state.login.accessToken);

  useEffect(() => {}, [isLoggedIn]);

  const navigate = useNavigate();
  const navigateToStackHistory = (theRouteUrl) => {
    const navigateUrl = "/stack-data/" + theRouteUrl;
    navigate(navigateUrl);
  };

  const convertToJalali = (x) => {
    const A = x.slice(0, 10);
    const B = x.slice(11, 19);
    const C = new Date(A);
    const D = new Intl.DateTimeFormat("fa-IR").format(C);
    return D + " " + "(" + B + ")";
  };

  const shouldShowTheWord = () => {
    const shouldShow = /^ایستگاه/;
    return !shouldShow.test(props.data.stationName);
  };

  if (
    props.type === "OPSGA" &&
    props.data.latitude &&
    props.data.device_id !== 105
  ) {
    return (
      <Marker
        position={[props.data.latitude, props.data.longitude]}
        icon={stackIcon}
      >
        <Popup position={[props.data.latitude, props.data.longitude]}>
          <div className="text-center pr-2 pt-2">
            <div width="100%">
              <h5 className="mx-2 d-inline">{props.data.stationName}</h5>
            </div>
            <div className="border p-3 bg-secondary text-bg-secondary">
              <div className="row">
                <div className="col">
                  <p className="popupText">
                    <strong>شهر : </strong>
                    {props.data.city}
                  </p>
                </div>
                <div className="col">
                  <p className="popupText">
                    <strong>استان : </strong>
                    {props.data.province}
                  </p>
                </div>
              </div>
              <div>
                <div className="row">
                  <div className="col">
                    <p className="popupText">
                      <strong>CO: </strong>
                      {props.data.co}
                      <sub>ppm</sub>
                    </p>
                  </div>
                  <div className="col">
                    <p className="popupText">
                      <strong>
                        SO<sub>2</sub>:&nbsp;
                      </strong>
                      {props.data.so2}
                      <sub>ppm</sub>
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <p className="popupText">
                      <strong>NO: </strong>&nbsp;
                      {props.data.no}
                      <sub>ppm</sub>
                    </p>
                  </div>
                  <div className="col">
                    <p className="popupText">
                      &nbsp; &nbsp;
                      <strong>
                        NO<sub>2</sub>:&nbsp;
                      </strong>
                      {props.data.no2}
                      <sub>ppm</sub>
                    </p>
                  </div>
                </div>
                <div className="row">
                  {props.data.device_id !== 104 ? (
                    <div className="col">
                      <p className="popupText">
                        &nbsp; &nbsp;
                        <strong>Flow: </strong>&nbsp;
                        {props.data.flow}
                        <sub>
                          m<sup>3</sup>/s
                        </sub>
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="col">
                    <p className="popupText">
                      &nbsp; &nbsp;
                      <strong>
                        O<sub>2</sub>:&nbsp;
                      </strong>
                      &nbsp;
                      {props.data.o2}
                      <sub>
                        <sub>%Vol</sub>
                      </sub>
                    </p>
                  </div>
                </div>
              </div>
              <br />
              <h6 dir="rtl">
                <strong>آخرین دیتا: </strong> &nbsp;
                {/* <span dir="ltr">{jalaliDate}</span> */}
                <span className="text-white ss01" dir="ltr">
                  {convertToJalali(props.data.ccreated_datetime)}
                </span>
              </h6>

              {isLoggedIn ? (
                <div className="d-inline p-0">
                  <button
                    className="btn btn-dark m-3"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigateToStackHistory(props.data.slug)}
                  >
                    تاریخچه
                  </button>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </Popup>
      </Marker>
    );
  } else if (
    props.type === "OPSGA" &&
    props.data.latitude &&
    props.data.device_id === 105
  ) {
    return (
      <Marker
        position={[props.data.latitude, props.data.longitude]}
        icon={stackIcon}
      >
        <Popup position={[props.data.latitude, props.data.longitude]}>
          <div className="text-center px-1 pt-2">
            <div className="mx-2 my-2" width="100%">
              <h5>{props.data.stationName} </h5>
            </div>
            <div className="border p-3 bg-secondary text-bg-secondary text-start">
              <div className="row">
                <div className="col">
                  <p className="popupText">
                    <strong>شهر : </strong>
                    {props.data.city}
                  </p>
                </div>
                <div className="col">
                  <p className="popupText">
                    <strong>استان : </strong>
                    {props.data.province}
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-auto">
                  <p className="popupText">
                    <strong>Dust: </strong>
                    {!isNaN(Number(props.data.dust)) ? (
                      <>
                        {Number(props.data.dust).toFixed(0)}
                        <sub>
                          mg/m<sup>3</sup>
                        </sub>
                      </>
                    ) : (
                      "-"
                    )}
                  </p>
                </div>
                <div className="col-auto">
                  <p className="popupText">
                    <strong>Dust_norm: </strong>
                    {!isNaN(Number(props.data.dust_norm)) ? (
                      <>
                        {Number(props.data.dust_norm).toFixed(0)}
                        <sub>
                          mg/nm<sup>3</sup>
                        </sub>
                      </>
                    ) : (
                      "-"
                    )}
                  </p>
                </div>
                <div className="col-auto">
                  <p className="popupText">
                    <strong>Flow: </strong>
                    {!isNaN(Number(props.data.flow)) ? (
                      <>
                        {Number(props.data.flow).toFixed(0)}
                        <sub>
                          m<sup>3</sup>/s
                        </sub>
                      </>
                    ) : (
                      "-"
                    )}
                  </p>
                </div>
                {/* <div className="col">
                  <p className="popupText">
                    &nbsp; &nbsp;
                    <strong>
                      O<sub>2</sub>:&nbsp;
                    </strong>
                    &nbsp;
                    {!isNaN(Number(props.data.o2)) ? (
                      <>
                        {Number(props.data.o2).toFixed(2)}
                        <sub>
                          <sub>%Vol</sub>
                        </sub>
                      </>
                    ) : (
                      "-"
                    )}
                  </p>
                </div> */}
              </div>

              <div className="row">
                <div className="col">
                  <p className="popupText">
                    <strong>Temperature: </strong>&nbsp;
                    {!isNaN(Number(props.data.flow)) ? (
                      <>
                        {Number(props.data.amb).toFixed(1)}
                        <sub>℃</sub>
                      </>
                    ) : (
                      "-"
                    )}
                  </p>
                </div>
              </div>

              <br />
              <h6 dir="rtl" className="text-center">
                <strong>آخرین دیتا: </strong>
                &nbsp;
                <span className="ss01 text-white" dir="ltr">
                  {props.data.ccreated_datetime
                    ? convertToJalali(props.data.ccreated_datetime)
                    : props.data.created_datetime
                    ? convertToJalali(props.data.created_datetime)
                    : "-"}
                </span>
              </h6>
            </div>
          </div>
        </Popup>
      </Marker>
    );
  }
};

export default StacksMarker;
